import React, { useState, useLayoutEffect, useContext } from "react";
import ApiScreenshot from "../../../app/api/admin/screenshot/ApiScreenshot";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import Loader from "../../components/loader";
import { Link } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FileLib from "../../../inc/FileLib";
import DateLib from "../../../inc/DateLib";
import Routes from "../../../inc/Routes";
import { Route } from "../../../inc/Pages";
import { SOURCE_LABELS } from "./index";
import "./styles.css";

// Ссылка на карточку устройства из ЧУЖОГО раздела: contextPage.routes знает только свой раздел,
// а лукапа по имени реестр pages не даёт — собираем Route по той же маске из дерева роутов.
const DEVICE_SHOW_ROUTE = new Route('devices.show', { mask: Routes.parseName('devices.show') });

// Карточка снимка (read-only): сам кадр в полный размер + атрибуция. Поля dir/size/type_storage/
// updated_at приходят только на show (BaseResource::isDetailed на бэкенде), в списке их нет.
export function ScreenshotShow({ ...other }) {
    // withContent={false} — карточка read-only: рендерим контент напрямую, БЕЗ движка Content
    // (иначе роутерный withContent=true обернул бы её в форму с кнопками «редактировать/удалить»,
    // а снимок ни править, ни удалять через API нельзя). Тот же приём, что в карточке замера.
    return <Page {...other} withContent={false}>
        <ScreenshotShowContent/>
    </Page>;
}

function ScreenshotShowContent() {
    const contextPage = useContext(ContextPage);

    const [_screenshot, set_screenshot] = useState(null); // null — ещё грузится
    const [_notFound, set_notFound] = useState(false);    // 404: снимка нет

    useLayoutEffect(() => {
        contextPage.setTitle('Снимок');
        (async () => {
            const data = await ApiScreenshot.Show(contextPage.id).getResponse();
            if (data === null) { set_notFound(true); return; }
            set_screenshot(data);
            // setTitle питает и document.title, и имя записи в хлебных крошках (breadcrumb ← app.title).
            contextPage.setTitle(`Снимок #${data.id}`);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (_notFound) return <div className="screenshots__empty">Снимок не найден.</div>;
    if (_screenshot === null) return <Loader/>;

    return <div className="screenshots__card">
        <div className="screenshots__card-frame">
            {_screenshot.public_url
                ? <img className="screenshots__card-img" src={_screenshot.public_url}
                    alt={`Снимок #${_screenshot.id}`}/>
                : <div className="screenshots__empty">Файла нет на диске</div>}
        </div>

        <dl className="screenshots__card-props">
            <dt>Устройство</dt>
            <dd><DeviceCell deviceId={_screenshot.device_id}/></dd>

            <dt>Источник</dt>
            <dd>{SOURCE_LABELS[_screenshot.source] ?? _screenshot.source}</dd>

            {/* execute_id есть только у кадров задач — у снимков крона ключа нет вовсе. */}
            {_screenshot.execute_id ? <>
                <dt>Запуск</dt>
                <dd>#{_screenshot.execute_id}</dd>
            </> : null}

            <dt>Снят</dt>
            <dd>{DateLib.formatterDateTime(_screenshot.created_at)}</dd>

            <dt>Файл</dt>
            <dd className="screenshots__card-file">{_screenshot.name}</dd>

            {/* size === null — запись есть, а файла на диске уже нет (так и задумано бэкендом). */}
            <dt>Размер</dt>
            <dd>{FileLib.formatterSize(_screenshot.size) ?? 'файла нет на диске'}</dd>

            {_screenshot.dir ? <>
                <dt>Каталог</dt>
                <dd className="screenshots__card-file">{_screenshot.dir}</dd>
            </> : null}
        </dl>

        {_screenshot.public_url ? (
            <a className="screenshots__card-link" href={_screenshot.public_url}
                target="_blank" rel="noopener noreferrer">
                <OpenInNewIcon fontSize="small"/> Открыть оригинал в новой вкладке
            </a>
        ) : null}
    </div>;
}

// Устройство снимка. null — не редкость и не ошибка выдачи: файл лежит в каталоге снимков, но
// устройство по нему не определилось (напр. кадр задачи, чью строку истории уже снесла чистка).
// Бэкенд отдаёт такую запись как есть, и прятать её тут тоже незачем.
function DeviceCell({ deviceId }) {
    if (!deviceId) return <span className="screenshots__muted">не определено</span>;

    const url = DEVICE_SHOW_ROUTE.url({ id: deviceId });
    return url ? <Link to={url} title="Карточка устройства">#{deviceId}</Link> : <span>#{deviceId}</span>;
}

export default ScreenshotShow;
